module.exports = __webpack_public_path__ + "static/media/time-to-care-today-tomorrow.bc86aa9d.svg";